module.exports = __webpack_public_path__ + "img/power-op-apk-gray_2x.a141d216.png";